export const CUSTOMER_ROUTES = {
  LIST: '/customers',
  DETAIL: '/customers/$id',
  CREATE: '/customers/create',
  EDIT: '/customers/$id/edit',
} as const;
